//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapActions, mapGetters} from "vuex"

export default {

    name: 'Sponsored',

    watch: {
        '$route.query': '$fetch',
    },

    async fetch() {

        try {
            const response = await this.doSponsored()
        } catch (e) {
            this.$logger.captureException(e)
        }
    },

    methods: {

        ...mapActions('search', {
            doSponsored: 'doSponsored',
        }),

        openNewTab(url) {
            window.open(url, '_blank')
        },

    },

    computed: {
        ...mapGetters('search', ['sponsored']),
    }

}
